<!-- =========================================================================================
File Name: TableDefault.vue
Description: Rendering default table
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card no-shadow>
		<configuration-navbar :handleOption="handleOption" :selected="schemaLocal" />

		<vx-card no-shadow>
			<label class="vs-input--label">{{ $t("TypeConfigConfigName") }}:</label>
			<vs-input
				v-show="schemaLocal.id === 0 || changeName"
				:disabled="false"
				size="large"
				v-model.trim="schemaLocal.name"
				class="w-full mb-base"
			/>
			<configuration-list-item
				@handleSelectedEmit="handleSelected"
				@handleChangesEmit="handleChangesEmit"
				@saveEmit="save"
				:schema="schemaLocal"
				:addTrigger="addTrigger"
				:saveTrigger="saveTrigger"
				class="mb-base"
			/>
		</vx-card>
	</vx-card>
</template>

<script>
// Vue components
import ConfigurationNavbar from "./ConfigurationNavbar.vue";
import ConfigurationListItem from "./ConfigurationListItem.vue";
// Models
import TypeConfiguration from "../../models/TypeConfiguration";
// Store
import moduleTypeConfigCrud from "@/store/type-config-crud/moduleTypeConfigCrud.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";

export default {
	props: {
		schema: {
			type: Object,
			required: false,
		},
		additionalFields: {
			type: Boolean,
		},
		showEditIcon: {
			type: Boolean,
		},
		defaultAction: {
			type: String,
		},
		defaultTipology: {
			type: String,
		},
	},
	components: {
		ConfigurationNavbar,
		ConfigurationListItem,
	},
	data() {
		return {
			selected: {},
			schemaLocal: JSON.parse(JSON.stringify(this.schema)),
			addTrigger: 0,
			saveTrigger: 0,
			activeStatus: 0,
			changeName: false,
		};
	},
	methods: {
		handleChangesEmit(data) {},
		handleSelected(val) {
			this.selected = val;
		},
		handleOption(option) {
			switch (option) {
				case "SAVE":
					this.saveTrigger += 1;
					break;
				case "ADD_PROPERTY":
					this.addTrigger += 1;
					break;
				case "CHANGE_NAME":
					this.changeName = true;
					break;
				case "DELETE":
					this.confirmDeleteField(this.selected);
					break;
				case "CANCEL":
					this.$emit("changeActiveTabEmit", 0);
					break;
				case "CLEAR_SELECTION":
					this.selected = null;
					break;
				default:
					break;
			}
		},
		confirmDeleteField(field) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Object.DeleteField.Text1") + ` "${field.name}"? ` + this.$t("Object.DeleteField.Text2"),
				accept: () => {
					this.deleteRecord(field);
				},
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord(field) {
			if (this.defaultAction === "DEFINITION") {
				this.deleteFromDefinition(field);
			}
			if (this.defaultAction === "LIST") {
				this.deleteFromStore(field);
			}
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Object.UserDeleted.Title"),
				text: this.$t("Object.UserDeleted.Text"),
			});
		},
		save(properties) {
			// Removemos algunas propiedades segun el tipo
			/* const json_properties = properties.map((property) => {
				const {
					label,
					name,
					required,
					type,
					minLength,
					maxLength,
					minimum,
					maximum,
					minItems,
					options,
					options_obj,
					options_composed,
				} = property;

				if (type === "select" || type === "radio" || type === "check") {
					return {
						label,
						name,
						required,
						type,
						options,
						minItems,
					};
				} else if (type === "check_obj") {
					return {
						label,
						name,
						required,
						type,
						options_obj,
					};
				} else if (type === "number") {
					return {
						label,
						name,
						required,
						type,
						minimum,
						maximum,
					};
				} else if (type === "text") {
					return {
						label,
						name,
						required,
						type,
						minLength,
						maxLength,
					};
				} else if (type === "anyOf") {
					return {
						label,
						name,
						required,
						type,
						options_composed,
						minItems,
					};
				} else {
					return property;
				}
			}); */

			const required = properties.filter((property) => property.required).map((property) => property.name);
			const reduceFormat = (accumulator, currentValue) => ({
				...accumulator,
				[currentValue.name]: this.formatProperty(currentValue),
			});
			const formattedProperties = properties.reduce(reduceFormat, {});

			if (this.schemaLocal.id > 0) this.updateConfigurationType(required, formattedProperties, properties);
			else this.createConfigurationType(required, formattedProperties, properties);
		},
		formatProperty(property) {
			const obj = {};
			const validateRequired = (required) => (required ? ["string"] : ["string", "null"]); // no required ["string","null"], required = ["string"]
			const validateRequiredNum = (required) => (required ? ["integer"] : ["integer", "null"]); // no required ["number","null"], required = ["number"]
			const validateRequiredBoolean = (required) => (required ? ["boolean"] : ["boolean", "null"]); // no required ["number","null"], required = ["number"]

			switch (property.type) {
				case "select":
				case "radio":
					obj.enum = property.required
						? property.options.map((value) => (isNaN(value) ? value.trim() : +value))
						: property.options.map((value) => (isNaN(value) ? value.trim() : +value)).concat(["", null]);
					obj.type = property.required
						? Array.from(new Set(property.options.map((value) => (isNaN(value) ? "string" : "integer"))))
						: Array.from(
								new Set(property.options.map((value) => (isNaN(value) ? "string" : "integer")))
						  ).concat(["", null]);
					break;
				case "check":
					obj.minItems = 0;
					obj.type = "array";
					obj.items = {
						enum: property.options.map((value) => value.trim()),
						type: Array.from(
							new Set(property.options.map((value) => (isNaN(value) ? "string" : "integer")))
						),
					};
					if (property.required) {
						obj.minItems = 1;
					}
					break;
				case "check_obj":
					obj.minItems = 0;
					obj.type = "array";
					obj.items = {
						enum: property.options_obj.map(({value}) => value),
						type: Array.from(
							new Set(property.options_obj.map(({value}) => (isNaN(value) ? "string" : "integer")))
						),
					};
					if (property.required) {
						obj.minItems = 1;
					}
					break;
				case "hour":
				case "location":
				case "text":
					obj.minLength = property.minLength ? property.minLength : 1;
					obj.maxLength = property.maxLength ? property.maxLength : 250;
					obj.type = validateRequired(property.required);
					break;
				case "number":
					obj.type = validateRequiredNum(property.required);
					obj.minimum = property.minimum ? property.minimum : 1;
					obj.maximum = property.maximum ? property.maximum : 1000000;
					break;
				case "email":
					obj.pattern =
						"^([a-z0-9-+*=&'/?^_}{~|`]+)(.?[a-z0-9-+*=&'/?^_}{~|`]+)*@[a-z0-9]+((-|.)[a-z0-9]+)*(.[a-z0-9]{1,20})$";
					obj.type = validateRequired(property.required);
					break;
				case "url":
				case "file":
				case "img":
					obj.format = "uri";
					obj.type = validateRequired(property.required);
					break;
				case "date":
					obj.format = "date";
					obj.type = validateRequired(property.required);
					break;
				case "boolean":
					obj.type = "boolean";
					break;
				case "anyOf":
					obj.anyOf = property.options_composed.map((opt_comp) => {
						if (opt_comp.type === "text") {
							const {minimum, maximum, values, ...res} = opt_comp;
							return {...res, type: validateRequired(property.required)};
						} else if (opt_comp.type === "number") {
							const {minLength, maxLength, values, ...res} = opt_comp;
							return {...res, type: validateRequiredNum(property.required)};
						} else {
							return {
								type: validateRequiredBoolean(property.required),
								enum: opt_comp.values.length <= 0 ? [true, false] : [...opt_comp.values],
							};
						}
					});
					break;
				default:
					break;
			}
			return obj;
		},
		async createConfigurationType(required, properties, json_properties) {
			this.schemaLocal.status_id = this.$store.state.moduleCommon.status.find(({name}) => name === "ACTIVE").id;
			this.schemaLocal.json_base.properties = properties;
			this.schemaLocal.json_base.required = required;
			this.schemaLocal.json_properties = json_properties;

			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleTypeConfigCrud/addTypeConfig", this.schemaLocal);
				this.$vs.notify({
					color: "success",
					title: this.$t("TitleSuccessTypeConfigCreated"),
					text: this.$t("TextSuccessTypeConfigCreated"),
				});
				this.$vs.loading.close();
				this.$emit("consultTypeConfigEmit");
				this.cancelEdit();
			} catch (error) {
				this.$vs.loading.close();
				console.error(err);
				this.$vs.notify({
					color: "danger",
					title: this.$t("TitleSuccessTypeConfigCreatedError"),
					text: this.$t("TextSuccessTypeConfigCreatedError"),
				});
			}
		},
		async updateConfigurationType(required, properties, json_properties) {
			const typeConfiguration = new TypeConfiguration(this.schemaLocal);
			typeConfiguration.json_base.properties = properties;
			typeConfiguration.json_base.required = required;
			typeConfiguration.json_properties = json_properties;

			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleTypeConfigCrud/updateTypeConfig", typeConfiguration);
				this.$vs.notify({
					color: "success",
					title: this.$t("TitleConfirmTypeConfigUpdate"),
					text: this.$t("TextConfirmTypeConfigUpdate"),
				});
				this.$vs.loading.close();
				this.$emit("consultTypeConfigEmit");
				this.cancelEdit();
			} catch (error) {
				this.$vs.loading.close();
				console.error(error);
				this.$vs.notify({
					color: "danger",
					title: this.$t("TitleSuccessTypeConfigCreatedError"),
					text: this.$t("TextSuccessTypeConfigCreatedError"),
				});
			}
		},
		handleError(status) {
			if (status === 401) {
				throw new BadRequestError();
			}
			if (status === 500) {
				throw new ServerError();
			}

			if (status === 722) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Roles.Permissions.NotPermissionsTitle"),
					text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${error.error}`,
					time: 5000,
				});
			}
		},
		cancelEdit() {
			this.$emit("changeActiveTabEmit", 0);
		},
	},
	created() {
		if (!moduleTypeConfigCrud.isRegistered) {
			this.$store.registerModule("moduleTypeConfigCrud", moduleTypeConfigCrud);
			moduleTypeConfigCrud.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
		if (this.$store.state.moduleSchedule.eventSatusLabels.length <= 0) {
			this.$store
				.dispatch("moduleSchedule/fetchEventStatusLabel")
				.then((res) => {})
				.catch((err) => {
					console.error(err);
				});
		}
	},
};
</script>

<style lang="scss" scoped>
.scroll-area--content-options {
	margin: auto;
	width: 100%;
	min-height: auto;
	max-height: 150px;
}
</style>
